<template>
    <form name="form_chk" id="form_chk" method="post">
        <!-- <input type="hidden" id="m" name="m" value="service"/> -->
        <!-- <input type="hidden" id="token_version_id" name="token_version_id" :value="tokenVersionId"/>
        <input type="hidden" id="enc_data" name="enc_data" :value="encData"/>
        <input type="hidden" id="integrity_value" name="integrity_value" :value="integrityValue"/> -->
        <input type="hidden" id="mobile_auth_url" name="mobile_auth_url" :value="mobile_auth_url"/>
    </form>
    <form name="form_ipin" id="form_ipin">
        <!-- <input type="hidden" id="token_version_id" name="token_version_id" :value="ipinTokenVersionId"/>
        <input type="hidden" id="enc_data" name="enc_data" :value="ipinEncData"/>
        <input type="hidden" id="integrity_value" name="integrity_value" :value="ipinIntegrityValue"/> -->
        <input type="hidden" id="ipin_auth_url" name="ipin_auth_url" :value="ipin_auth_url"/>
    </form>
</template>

<script>
export default{
    data() {
        return {
            mobile_auth_url:'',
            ipin_auth_url:'',
        }
    },
    methods: {
        // 본인인증 팝업
        async fnPopup(niceType) {
            console.log('running niceId: ' + niceType);
            this.$store.commit('getNiceType', niceType);
            this.$store.commit('getIpinType', '');
            var check = true;

            if(niceType == 'findPw'){
                var findId = document.querySelector('#memNiceFindId').value;

                
                if(findId == ''){
                    alert('아이디를 입력해주세요.');
                    return false;
                } 

                await this.axios.get(this.api.member.dupId, {
                    params: {
                        memId: findId
                    }
                })
                .then(res => {
                    const data = res.data;

                    if(data.result.check == 'N'){
                        this.$store.commit('getFindMemId', findId);
                        
                    }else{
                        alert('아이디가 존재하지 않습니다.');
                        check = false;
                    }
                    
                });

            }
            if(check){
                const popup = window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
                await this.getAccessToken('A');
                if(!this.mobile_auth_url){
                    popup?.close();
                    return;
                }
                popup.location.href = this.mobile_auth_url;
            }
        },

        // ipin 팝업
        async popIpinAuth(ipinType) {
            this.$store.commit('getIpinType', ipinType);
            this.$store.commit('getNiceType', '');
            var check = true;

            if(ipinType == 'findPw'){
                var findId = document.querySelector('#memIpinFindId').value;

                
                if(findId == ''){
                    alert('아이디를 입력해주세요.');
                    return false;
                } 

                await this.axios.get(this.api.member.dupId, {
                    params: {
                        memId: findId
                    }
                })
                .then(res => {
                    const data = res.data;

                    if(data.result.check == 'N'){
                        this.$store.commit('getFindMemId', findId);
                        
                    }else{
                        alert('아이디가 존재하지 않습니다.');
                        check = false;
                    }
                    
                });

            }
            if(check){
                const popup = window.open('', 'popupIPIN2', 'width=450,height=550,top=100,left=100,fullscreen=no,menubar=no,status=no,toolbar=no,titlebar=yes,location=no,scrollbar=no');
                await this.getAccessToken('B');
                if(!this.ipin_auth_url){
                    popup?.close();
                    return;
                }
                popup.location.href = this.ipin_auth_url;
            }
        },
        iosAlert(msg) {
            var ios = (/iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()));
            if (ios) {
                alert(msg);
            }
        },

        // nice api 토큰 발급
        getAccessToken(type) {
            return this.axios
                .get(this.api.token.getToken, {
                    params: {
                        productType: type
                    }
                })
                .then(res => {
                    const data = res.data
                    if(data.error){
                        alert(data.error || '본인인증 모듈 로딩에 실패하였습니다. 잠시 후 다시 시도해주세요.')
                        return
                    }
                    if(type == 'A'){
                        console.log(data.auth_url);
                        this.mobile_auth_url = data.auth_url
                    }else{
                        this.ipin_auth_url = data.auth_url
                    }
                    // if(type == 'A'){
                    //     this.tokenVersionId = data.token_version_id
                    //     this.encData = data.enc_data
                    //     this.integrityValue = data.integrity
                    // }else{
                    //     this.ipinTokenVersionId = data.token_version_id
                    //     this.ipinEncData = data.enc_data
                    //     this.ipinIntegrityValue = data.integrity
                    // }
                    // this.key = data.key
                    // this.iv = data.iv
                    // const result = {
                    //     key: this.key,
                    //     iv: this.iv
                    // }
                    // this.$nextTick(() => {
                    //     type == 'A' ? this.$store.commit('setNice', result) : this.$store.commit('setNiceIpin', result)
                    // })
                    // setTimeout(() => {
                    //     alert(type + ': ' + JSON.stringify(result))
                    //     alert(type + ': ' + JSON.stringify(this.$store.state.memberStore.nice))
                    //     alert(type + ': ' + JSON.stringify(this.$store.state.memberStore.niceIpin))
                    // }, 1000);
                }).catch(err => {
                    console.error(err)
                        alert('본인인증 모듈 로딩에 실패하였습니다. 잠시 후 다시 시도해주세요.')
                        return
                })
        },
    },
    mounted() {
        // getAccessToken은 팝업 열기 직전에 호출하므로 초기 발급 불필요
        // this.getAccessToken('A')
        // this.getAccessToken('B')
    },
}
</script>